import React from "react";
import "./home.css";
import SectionContainer from "../../../components/landing/section-container";
import { Stack, Typography } from "@mui/material";

function HomePage() {
  return (
    <SectionContainer id="home">
      <Stack className="home" spacing={2} sx={{ padding: 5 }}>
        <Typography variant="h2">Residencia Cactus</Typography>
        <Typography
          sx={{
            width: { xs: "90%", sm: "80%", md: "60%" },
          }}
        >
          En Residencia Estudiantil Cactus, te ofrecemos más que un lugar donde
          vivir; te brindamos un hogar acogedor y seguro para que te enfoques en
          tus estudios y crecimiento personal.
        </Typography>
        <Typography
          sx={{
            width: { xs: "90%", sm: "70%", md: "50%" },
          }}
        >
          ¡Bienvenido a tu nuevo hogar lejos de casa!
        </Typography>
      </Stack>
    </SectionContainer>
  );
}

export default HomePage;
